<template>
  <panel-main-template>
    <template v-slot:page-title>
      Дополнительные аккаунты
      <hints
          :title="'Узнай как работать с данным разделом за несколько минут'"
          :type="'youtube'"
          :url="getYotubeLink('addUsers')"
      ></hints>
    </template>
    <template v-slot:page-info>
      В данном разделе вы можете создать дополнительного пользователя.<br />
      Это может быть полезно, чтобы разделить учетные записи и у каждого администратора была своя.
      Или, возможно, необходимо дать доступ веб-мастеру для интеграции виджета для вашего сайта и т.д...<br>
      Назначьте ему необходимые права, придумайте надежный пароль.<br /> <br />
      Обращаем ваше внимание, что доп.аккаунту по умолчанию <span class="text-danger">недоступны разделы:
      Настройки, Доп.аккаунты, СМС, Оплата услуг</span> (этим управляете только вы)<br />
      Максимальное количество аккаунтов - 65
    </template>
    <template v-slot:page-content>
      <div v-if="users.length > 0" class="section-title">Мои доп.аккаунты</div>
      <div class="add-account--items mrg-t-10">
        <div v-if="users.length === 0" class="alert alert-sm alert-danger">
          У вас нет созданных доп.аккаунтов
        </div>
        <div class="shadow-card mrg-t-10" v-for="item in users" :key="item.id">
          <div class="email">{{ item.email }}</div>
          <div class="name">{{ item.username }}</div>
          <div class="companies">
            <div
              v-for="comp in item.companies"
              :key="comp.company_id"
            >
              &#8226; {{comp.company.name}}, {{comp.company.address}}
            </div>
            <div class="text-danger" v-if="!item.companies.length">Требуется выбрать компании</div>
          </div>
          <div class="actions">
            <div @click="editUser(item.id)" class="btn btn-sm btn-info">Изменить</div>
            <div @click="deleteAdduser(item.id)" class="btn btn-sm btn-danger">Удалить</div>
          </div>
        </div>
      </div>
      <div class="add-account--new-form mrg-t-25">
        <div class="section-title">Добавить пользователя</div>
        <form class="mrg-t-15" @submit.prevent="register">
          <div class="shadow-card">
            <div class="text-bold">Основные данные</div>
            <div class="input-block mrg-t-15">
              <label for="new_mail">E-mail <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.email = ''"
                  @blur="vEmail"
                  id="new_mail"
                  v-model="newUser.email"
              />
              <div class="form-error">{{ formError.email }}</div>
            </div>
            <div class="input-block">
              <label for="new_name">Имя <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.username = ''"
                  @blur="vUsername"
                  id="new_name"
                  v-model="newUser.username"
              />
              <div class="form-error">{{ formError.username }}</div>
            </div>
            <div class="input-block">
              <label for="new_password">Пароль <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.password = ''"
                  @blur="vPassword"
                  id="new_password"
                  v-model="newUser.password"
              />
              <div class="form-error">{{ formError.password }}</div>
            </div>
          </div>
          <div class="shadow-card mrg-t-10">
            <div class="input-block">
              <label><b>Права и разрешения будущего пользователя</b> <span class="req">*</span></label>
              <permissions-list
                  @changeValue="changePermSelect"
                  :reset="resetPermissions"
                  class="mrg-t-15"
              ></permissions-list>
            </div>
          </div>
          <div class="shadow-card mrg-t-10">
            <div class="input-block">
              <label><b>Компании, которые будут доступны будущему пользователю</b> <span class="req">*</span></label>
              <simple-select-checkbox
                  :dataComponent="companyData"
                  :reset="resetCompany"
                  @changeValue="changeCompanySelect"
                  class="mrg-t-15"
              ></simple-select-checkbox>
            </div>
            <div class="input-block">
              <button type="submit" class="btn btn-sm btn-success">
                Добавить
              </button>
            </div>
          </div>

        </form>
      </div>

      <right-modal :show="showEditModal" @closeRightModal="closeSraffModal">
        <div slot="body">
          <edit-adduser
            :dataUser="editUserData"
            :companyData="companyData"
            :show="showEditModal"
            @updateUser="updatedUser"
          ></edit-adduser>
        </div>
      </right-modal>

      <popup
          :closeButton="deleteUserPopup.closeButton"
          :actionButton="deleteUserPopup.actionButton"
          :actionClass="deleteUserPopup.actionClass"
          :show="deleteUserPopup.show"
          @closePopup="closeDeleteUserPopup"
          @actionPopup="deleteUserSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          Удаление доп.аккаунта
        </div>
      </popup>

    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src

import PanelMainTemplate from "../../components/panel/MainTemplate";
import RightModal from "../../components/RightModal";
import EditAdduser from "../../components/panel/adduser/EditAdduser";
import Validator from "../../components/libraries/Validator";
import Popup from "@/components/Popup";
import Hints from "@/components/Hints";
import youtubeMixin from "@/components/mixins/Youtube";
import SimpleSelectCheckbox from "@/components/SimpleSelectCheckbox";
import adduserRepository from "../../repositories/adduser";
import userRepository from "../../repositories/user";
import PermissionsList from "../../components/panel/adduser/PermissionsList.vue";

const validator = new Validator();

export default {
  name: "AddAccount",
  components: {
    PermissionsList,
    SimpleSelectCheckbox,
    Hints,
    Popup,
    EditAdduser,
    RightModal,
    PanelMainTemplate
  },
  mixins: [youtubeMixin],
  data() {
    return {
      newUser: {
        email: "",
        username: "",
        password: "",
        permissions: [],
        companies: []
      },
      formError: {
        email: "",
        username: "",
        password: ""
      },
      resetPermissions: 0,
      resetCompany: 0,
      companyData: [],
      users: [],
      showEditModal: false,
      editUserData: {},
      deleteUserPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedUserId: null
    };
  },
  watch: {

  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vEmail().result === "error" ? errorCount++ : "";
      this.vUsername().result === "error" ? errorCount++ : "";
      this.vPassword().result === "error" ? errorCount++ : "";

      return errorCount;
    },
  },
  methods: {
    vEmail() {
      let validate = validator.validate([
        {
          fieldName: "E-mail",
          value: this.newUser.email,
          type: "required",
          length: 255
        },
        { fieldName: "E-mail", value: this.newUser.email, type: "email" }
      ]);
      validate.result === "error"
        ? (this.formError.email = validate.message)
        : (this.formError.email = "");
      return validate;
    },
    vUsername() {
      let validate = validator.validate([
        {
          fieldName: "Имя пользователя",
          value: this.newUser.username,
          type: "required",
          length: 255
        }
      ]);
      validate.result === "error"
        ? (this.formError.username = validate.message)
        : (this.formError.username = "");
      return validate;
    },
    vPassword() {
      let validate = validator.validate([
        {
          fieldName: "Пароль",
          value: this.newUser.password,
          type: "required",
          length: 255
        }
      ]);
      validate.result === "error"
        ? (this.formError.password = validate.message)
        : (this.formError.password = "");
      return validate;
    },
    editUser(user_id) {
      this.showEditModal = true;
      for (let key in this.users) {
        if (+this.users[key].id === +user_id) {
          this.editUserData = this.users[key];
        }
      }
    },
    closeSraffModal() {
      this.showEditModal = false;
    },
    changePermSelect(val) {
      this.newUser.permissions = val;
    },
    changeCompanySelect(val){
      this.newUser.companies = val;
    },
    updatedUser() {
      this.closeSraffModal();
      this.getUsers();
    },
    async getUsers() {
      this.$store.dispatch("startPreloader");

      await adduserRepository.getUsersWithPerm().then(resp => {
        this.users = resp.data;
        this.getCompanyData();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    register() {
      if (this.validateData) {
        return false;
      }
      if(!this.newUser.permissions.length){
        this.$store.dispatch("addNotification", {
          text: 'Не выбраны разрешения будущего пользователя',
          time: 3,
          color: "danger"
        });
        return false;
      }
      if(!this.newUser.companies.length){
        this.$store.dispatch("addNotification", {
          text: 'Не выбраны филиалы будущего пользователя',
          time: 3,
          color: "danger"
        });
        return false;
      }

      this.$store.dispatch("startPreloader");

      adduserRepository.register({
        email: this.newUser.email.trim(),
        username: this.newUser.username.trim(),
        password: this.newUser.password.trim(),
        permissions: JSON.stringify(this.newUser.permissions),
        companies: JSON.stringify(this.newUser.companies)
      }).then(resp => {
        if(resp.data.result === 'ok'){
          this.newUser.email = '';
          this.newUser.username = '';
          this.newUser.password = '';
          this.resetCompany++;
          this.resetPermissions++;
          this.getUsers();
          this.$store.dispatch("addNotification", {
            text: 'Пользователь успешно создан',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getCompanyData() {
      this.$store.dispatch("startPreloader");

      userRepository.getCompanyData().then(resp => {
        this.companyData = this.prepareCompanyData(resp.data.data);
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    preparePermData(val) {
      let result = [];
      for (let key in val) {
        let obj = {};
        obj.id = val[key].name;
        obj.name = val[key].description;
        result.push(obj);
      }
      return result;
    },
    prepareCompanyData(data){
      let result = [];
      for (let key in data){
        let obj = {};
        obj.id = data[key].company.id;
        obj.name = data[key].company.name +', ' +data[key].company.address;
        result.push(obj);
      }
      return result;
    },
    deleteAdduser(userId){
      this.deleteUserPopup.show = true;
      this.deletedUserId = userId;
    },
    closeDeleteUserPopup(){
      this.deleteUserPopup.show = false;
    },
    deleteUserSubmit(){
      this.$store.dispatch("startPreloader");

      adduserRepository.delete({ user_id: this.deletedUserId }).then(resp => {
        if(resp.data.result === 'ok'){
          this.closeDeleteUserPopup();
          this.getUsers();
          this.$store.dispatch("addNotification", {
            text: 'Пользователь успешно удален',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
  },
  metaInfo: {
    title: "Доп.аккаунты - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  async created() {
    await this.getUsers();
  }
};
</script>

<style scoped lang="less">
.add-account--new-form {
  width: 100%;

  form{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;

    &>.shadow-card{
      width: 60%;
    }
  }
}
.add-account--items{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;

  .shadow-card{
    margin-right: 10px;
    .email{
      font-weight: 700;
    }
    .name{
      margin-top: 4px;
      color: gray;
    }
    .companies{
      margin-top: 5px;
      font-size: 10px;
      color: gray;
    }
    .actions{

      &>div{
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 1100px) {
  .add-account--new-form {
    form{
      &>.shadow-card{
        width: 100%;
      }
    }
  }
}
@media (max-width: 450px) {
  .add-account--items{

    .shadow-card{
      margin-right: 0;
      width: 100%;
    }
  }
}
</style>
